import createReducer, { ActionCreatorHelper } from '@hh.ru/redux-create-reducer';

import { ProfileDto } from 'src/types/profile';

const UPDATE_PROFILE = `UPDATE_PROFILE`;

interface PayloadTypes {
    [UPDATE_PROFILE]: Partial<ProfileDto>;
}

const actionCreator = ActionCreatorHelper<PayloadTypes>();

export const _dangerousUpdateProfileAction = actionCreator(UPDATE_PROFILE);

export default createReducer<ProfileDto | null, PayloadTypes>(null, {
    [UPDATE_PROFILE]: (state, action) => {
        if (state) {
            return {
                ...state,
                ...action.payload,
            };
        }

        return state;
    },
});
